import { GrcNotify, NotifyType } from '@grc/ui-package';
import {
  BusinessEntitiesResponse,
  fetchBusinessEntities
} from '@grc/ui-shared';
import {
  businessEntityUrl,
  tenantService
} from '../../common/constants/url-constants';

// Old GET /businessentities query, used for the shapes the v1 routes cannot express.
const legacyUrl = (data: any): string => {
  const queryParams = new URLSearchParams();

  if (data.status !== undefined) {
    queryParams.append('status', data.status);
  }

  if (data.name) {
    queryParams.append('name', data.name);
  }

  if (data.entityType) {
    queryParams.append('entityType', data.entityType);
  }

  if (data.entityIds && data.entityIds.length > 0) {
    data.entityIds.forEach((id: string) => {
      queryParams.append('entityIds', id);
    });
  }

  if (data.accountId) {
    queryParams.append('accountId', data.accountId);
  }

  return `${businessEntityUrl}?${queryParams.toString()}`;
};

/**
 * Looks up business entities on Tenant's v1 routes where they fit (AB#7601):
 * locationIds -> byids (100 per call), a 2-100 character name -> search,
 * anything else -> the old GET /businessentities.
 * Returns the `{ data }` response (data may be empty), or undefined on failure.
 */
export const getBusinessEntities = async (
  fetchData: any,
  data: any
): Promise<BusinessEntitiesResponse | undefined> => {
  try {
    const response = await fetchBusinessEntities(
      fetchData,
      data,
      legacyUrl(data),
      (message: string) => GrcNotify({ message, status: NotifyType.Error }),
      tenantService
    );
    return response ?? undefined;
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};
